export const css = {
    root: '_3VdjSxRj',
    videoInstructions: '_3B3l2Oy3',
    videoWrapper: 'T70wikBf',
    videoTranscript: '_3CetwGFK',
    ' _key': 'afcpe-theme/afcpe/video/video'
};
export default css;
